import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Menu, Table, Header, Icon, Breadcrumb, Segment, Dropdown, Grid, Button, Input, Label, } from 'semantic-ui-react';
import moment from 'moment';
import { ColumnDefinition, useEmployerSpotlightPresentation } from './useEmployerSpotlightPresentationList';
import { SimplePageBar } from '../../Common/CommonComponents/SimplePageBar';
import { utils } from '../../../helpers/utils';


export function EmployerSpotlightPresentation() {

    const history = useHistory();
    const inputClassName = 'ui icon input fluid search-input';
    const [columns, recordsPerPage, totalRecords, pageNum,
        pageSizeOptions, searchRef, searchText, data, isLoading, sortOrderDesc, sortByField,
        isUpcoming, fromDate, toDate, fromDateRef, toDateRef,
        handlePageSizeChange, handleSearchChange, resetSearch, handlePaginationChange, handleSortChange, handleIsUpcomingChange,
        handleFromDateChange, handleToDateChange, resetFromDate, resetToDate
    ] = useEmployerSpotlightPresentation();

    const totalPages: number = Math.ceil(totalRecords / recordsPerPage);

    const paginationArray: (number | string)[] = utils.getPaginationArray(totalPages, pageNum);

    const handleCreateNewPresentation = () => {
        history.push('/createPresentation');
    };

    const yesterday = moment().add(-1, 'day').format('yyyy-MM-DD');
    const today = moment().format('yyyy-MM-DD');
    const tomorrow = moment().add(1, 'day').format('yyyy-MM-DD');

    return (
        <Container className='dashboard-container'>
            <div style={{ position: 'relative', width: '100%', marginTop: '1rem' }}>
                <Header as='h1' style={{ display: 'inline' }}>Employer Spotlight Presentations</Header>
                {
                    isUpcoming &&
                    <Button icon labelPosition='left' onClick={handleCreateNewPresentation} style={{ position: 'absolute', right: '0', top: '-0.4rem' }}>
                        <Icon name='plus' />
                        Create Presentation
                    </Button>
                }
            </div>
            <hr />
            <Breadcrumb>
                <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section active>Employer Spotlight Presentations</Breadcrumb.Section>
            </Breadcrumb>
            <Grid style={{ marginTop: '0.5rem' }}>
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Button.Group>
                            <Button color={isUpcoming ? 'blue' : 'grey'}
                                fluid
                                onClick={() => {
                                    if (!isUpcoming) {
                                        handleIsUpcomingChange(!isUpcoming);
                                    }
                                }}
                            >Upcoming</Button>
                            <Button color={isUpcoming ? 'grey' : 'blue'}
                                fluid
                                onClick={() => {
                                    if (isUpcoming) {
                                        handleIsUpcomingChange(!isUpcoming);
                                    }
                                }}
                            >Archived</Button>
                        </Button.Group>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <Label ribbon size='small' className='date-input-label'>From{fromDate ? ' (mm/dd/yyyy)' : ''} </Label>
                        <div className='ui input'>
                            <input type='date'
                                ref={fromDateRef}
                                onBlur={(event: any) => {
                                    if (event.target) {
                                        handleFromDateChange(event.target.value);
                                    }
                                }}
                                min={isUpcoming ? today: '0001-01-01'}
                                max = {!isUpcoming ? yesterday : '9999-01-01'}
                            //value={fromDate}
                            />
                        </div>
                        {
                            (isUpcoming ? (fromDate !== today ):(fromDate)) && <Button icon onClick={resetFromDate} style={{ marginLeft: '0.5rem' }}>
                                <Icon name='times' />
                            </Button>
                        }
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <Label ribbon size='small' className='date-input-label'>To{toDate ? ' (mm/dd/yyyy)' : ''}</Label>
                        <div className='ui input'>
                            <input type='date'
                                ref={toDateRef}
                                onBlur={(event: any) => {
                                    if (event.target) {
                                        handleToDateChange(event.target.value);
                                    }
                                }}
                                min={isUpcoming ? today: '0001-01-01'}
                                max={!isUpcoming ? yesterday : '9999-01-01'}
                            //value={fromDate}
                            />
                        </div>
                        {
                            ( !isUpcoming ? (toDate !== yesterday ): (toDate)) && <Button icon onClick={resetToDate} style={{ marginLeft: '0.5rem' }}>
                                <Icon name='times' />
                            </Button>
                        }
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>

                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className={isLoading ? inputClassName + ' loading' : inputClassName}>
                            {
                                searchText && <Button icon onClick={resetSearch}>
                                    <Icon name='times' />
                                </Button>
                            }
                            <input ref={searchRef} onChange={handleSearchChange} placeholder='Search...' />
                            <i aria-hidden="true" className="search icon"></i>
                        </div>
                    </Grid.Column>
                </Grid.Row>

            </Grid>
            <Segment color='red' loading={isLoading}>
                <Table basic='very' striped>
                    <Table.Header>
                        <Table.Row>
                            {
                                columns.map((column: ColumnDefinition, index: number) => {
                                    return <Table.HeaderCell key={index}
                                        title={column.sortable ? 'Click to toggle sort order' : ''}
                                        className={column.sortable ? 'data-grid sort-header' : ''}
                                        onClick={() => {
                                            if (column.sortable) {
                                                handleSortChange(column.columnName);
                                            }
                                        }}
                                    >
                                        <div className='data-grid header-wrapper'>{column.columnHeader}
                                            {
                                                column.sortable &&
                                                <Icon
                                                    name={sortByField === column.columnName ? (sortOrderDesc ? 'sort down' : 'sort up') : 'sort'}
                                                    className='data-grid sort-icon'
                                                />
                                            }
                                        </div>
                                    </Table.HeaderCell>
                                })
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            data.length === 0 &&
                            <Table.Row>
                                <Table.Cell colSpan={columns.length}>No data avaliable</Table.Cell>
                            </Table.Row>
                        }
                        {
                            data.length > 0 &&
                            data.map((row, rowIndex) => {
                                return (
                                    <Table.Row key={rowIndex}>
                                        {
                                            columns.map((col, colIndex ) => {
                                                if (col.decorator) {
                                                    return (
                                                        <Table.Cell key={colIndex}>{
                                                            col.decorator(row, data, rowIndex, colIndex)
                                                        }</Table.Cell>
                                                    );
                                                } else {
                                                    return <Table.Cell key={colIndex}>{row[col.columnName]}</Table.Cell>
                                                }

                                            })
                                        }

                                    </Table.Row>
                                );
                            })
                        }




                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='4'>
                                <div style={{ display: 'inline', position: 'relative', top: '0.75rem' }}>
                                    <span style={{ overflowX: "visible", whiteSpace: "nowrap" }}>
                                        Showing {Math.min((pageNum - 1) * recordsPerPage + 1, totalRecords)} to{" "}
                                        {pageNum * recordsPerPage > totalRecords
                                            ? totalRecords
                                            : pageNum * recordsPerPage}{" "}
                                        of
                                        {"  "} {totalRecords} entries{", "}
                                    </span>
                                    <Dropdown inline value={recordsPerPage} options={pageSizeOptions} onChange={handlePageSizeChange} />
                                    <span> records per page</span>
                                </div>
                                <Menu floated='right' pagination>
                                    <Menu.Item
                                        as='a'
                                        disabled={pageNum <= 1}
                                        icon onClick={(event) => {
                                            handlePaginationChange(pageNum - 1);
                                        }}
                                    >
                                        <Icon name='chevron left' />
                                    </Menu.Item>
                                    {
                                        paginationArray.map((item: number | string, index: number) => {
                                            if (typeof item === 'string') {
                                                return <Menu.Item key={index} as='a'>{item}</Menu.Item>
                                            } else {
                                                return <Menu.Item active={item === pageNum} key={index} as='a' onClick={(event) => {
                                                    handlePaginationChange(item as number);
                                                }}>{item}</Menu.Item>
                                            }
                                        })
                                    }
                                    <Menu.Item as='a' icon
                                        disabled={pageNum >= totalPages}
                                        onClick={(event) => {
                                            handlePaginationChange(pageNum + 1);
                                        }}
                                    >
                                        <Icon name='chevron right' />
                                    </Menu.Item>
                                </Menu>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Segment>


        </Container>
    );
}